import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "w-full bg-gray-lp-200 rounded-lg" }
const _hoisted_2 = /*#__PURE__*/_createVNode("th", {
  class: "sticky left-0 z-30 bg-gray-50 p-2 text-left",
  style: {"min-width":"48px"}
}, " No ", -1)
const _hoisted_3 = {
  class: "sticky left-12 z-30 bg-gray-50 p-2 text-left",
  style: {"min-width":"280px"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("th", { class: "w-auto text-left bg-gray-50 px-4 py-2" }, null, -1)
const _hoisted_5 = {
  class: "sticky left-0 z-20 bg-white p-2 text-center",
  style: {"min-width":"48px"}
}
const _hoisted_6 = {
  class: "sticky left-12 z-20 bg-white border-r p-2 text-left",
  style: {"min-width":"280px"}
}
const _hoisted_7 = { class: "w-auto text-left px-4 py-2 bg-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skeleton = _resolveComponent("skeleton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataTable, (section) => {
      return (_openBlock(), _createBlock("div", {
        key: section.title
      }, [
        _createVNode("table", null, [
          _createVNode("thead", null, [
            _createVNode("tr", null, [
              _hoisted_2,
              _createVNode("th", _hoisted_3, _toDisplayString(section.title), 1),
              _hoisted_4
            ])
          ]),
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(section.row, (item) => {
              return (_openBlock(), _createBlock("tr", { key: item }, [
                _createVNode("td", _hoisted_5, [
                  _createVNode(_component_skeleton, {
                    width: "2.5rem",
                    height: "1.2rem"
                  })
                ]),
                _createVNode("td", _hoisted_6, [
                  _createVNode(_component_skeleton, {
                    width: "15.5rem",
                    height: "1.2rem"
                  })
                ]),
                _createVNode("td", _hoisted_7, [
                  _createVNode(_component_skeleton, {
                    width: "72rem",
                    height: "1.2rem"
                  })
                ])
              ]))
            }), 128))
          ])
        ])
      ]))
    }), 128))
  ]))
}